// FILE: client/src/components/InstallPWAButton.js

import { useEffect, useState } from "react";

export default function InstallPWAButton() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [canInstall, setCanInstall] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setCanInstall(true);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setCanInstall(false);
  };

  if (!canInstall) return null;

  return (
    <button onClick={handleInstall} style={styles.button}>
      Install WatchParty
    </button>
  );
}

const styles = {
  button: {
    padding: "12px 18px",
    borderRadius: "14px",
    background: "linear-gradient(135deg, #7c3aed, #4f46e5)",
    border: "none",
    color: "white",
    fontWeight: 700,
    cursor: "pointer",
    boxShadow: "0 0 18px rgba(124,58,237,.5)",
    marginTop: "12px"
  }
};
